<div class="mp-header">
	<div class="mp-toolbar">
		<div class="mp-title" *ngIf="title" [style.font-size]="titleSize">{{ title }}</div>
		<div slot="end" class="mp-buttons" style="margin-inline-start:auto">
			<button class="mp-button mp-button--clear mp-button--icon-only" (click)="closeModal()" aria-label="Fechar">
				<mp-icon name="close" slot="icon-only"></mp-icon>
			</button>
		</div>
	</div>
</div>

<div class="mp-content viewer-content">
	<div
		class="zoom-area"
		(touchstart)="onTouchStart($event)"
		(touchmove)="onTouchMove($event)"
		(touchend)="onTouchEnd($event)"
		(dblclick)="onDoubleClick()"
	>
		<img #img [src]="src" [alt]="alt || title || ''" draggable="false" (error)="onImgError()" />
	</div>
</div>

<div class="mp-footer viewer-footer" *ngIf="text || actionLabel">
	<!-- Ancorado ACIMA da descrição, dentro do rodapé. Aqui o modal é uma coluna
	     flex (:host no .scss) em vez do par ion-content fullscreen + ion-footer:
	     o rodapé não fica POR CIMA da foto, fica abaixo dela. O motivo de o botão
	     morar no rodapé sobrevive à troca — a posição é relativa ao texto, então
	     descrição longa empurra o botão para cima em vez de ser encoberta. -->
	<div
		class="viewer-action-float"
		[class.viewer-action-float--still]="actionDisabled"
		*ngIf="actionLabel"
	>
		<button
			#actionBtn
			type="button"
			class="viewer-action"
			[class.viewer-action--light]="useLightAction"
			data-cy="viewerSelectItem"
			[disabled]="actionDisabled"
			[attr.aria-disabled]="actionDisabled"
			(click)="selectItem()"
		>
			<span class="viewer-action__label">{{ actionText | translate }}</span>
			<span class="viewer-action__puck" *ngIf="!actionDisabled" aria-hidden="true">
				<mp-icon class="viewer-action__icon" name="arrow-forward"></mp-icon>
			</span>
		</button>
	</div>
	<span class="mp-text" *ngIf="text" tabindex="0">{{ text }}</span>
</div>
